import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import withSession from '@/features/session/component/Session';
import { Spinner } from '@yaradigitallabs/ahua-react';

import type { User } from './features/session/types/session.types';
import { Header } from './components/Header';
import { config } from '@/utils/config';
import { useAppSelector } from './app/hooks';
import ErrorPage from './pages/error';

interface AppProps {
  signIn: () => void;
  signOut: () => void;
  user: User | null;
  isAuthorized: boolean;
}

const App = ({ signIn, signOut, user, isAuthorized }: AppProps) => {
  const { responseErrorStatus } = useAppSelector(state => state.session);
  if (
    responseErrorStatus == 401 ||
    responseErrorStatus == 404 ||
    responseErrorStatus == 403
  ) {
    return <ErrorPage errorStatusCode={responseErrorStatus} />;
  }
  return (
    <div className="w-full h-full">
      {user && <Header title={config.appName} signOut={signOut} />}
      <Suspense fallback={<Spinner />}>
        <Outlet context={{ signIn, isAuthorized }} />
      </Suspense>
    </div>
  );
};

export default withSession(App);
